import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'loadingDetail': false,
  'listDetail': [],
};

export const liquidationsList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.EMPTY_LIQUIDATIONS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.LOADING_LIQUIDATIONS_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.LOADING_LIQUIDATIONS_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'listDetail': action.response.data,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'listDetail': [],
    }),
  })(state, action);
};
